import React from "react";
import orderBy from "lodash/orderBy";
import Box from "@mui/material/Box";
import CardMedia from "@mui/material/CardMedia";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Label from "../../../components/Label";
import { getImage } from "../../../utils/images";
import useAuth from "../../../hooks/useAuth";

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  lazyLoad: "ondemand",
};

const styles = {
  image: {
    aspectRatio: "4/3",
    backgroundSize: "contain",
    backgroundColor: "#f8f9fb",
    borderRadius: "12px",
  },
  assetIdLabel: {
    position: "absolute",
    top: 6,
    left: 12,
    backdropFilter: "blur(8px)",
    "& > span": {
      borderRadius: 4,
    },
  },
  sliderContainer: {
    "& .slick-prev, & .slick-next": {
      "&:before": {
        color: "rgba(0, 0, 0, 0.8) !important",
        fontSize: "20px !important",
      },
    },
    "& .slick-prev": {
      left: "10px",
      zIndex: 1,
    },
    "& .slick-next": {
      right: "10px",
      zIndex: 1,
    },
  },
};

const isNA = value => {
  if (!value) return false;
  const normalized = String(value).trim().toLowerCase().replace(/\./g, "").replace(/\//g, "");
  return normalized === "na";
};

const notNA = value => value && !isNA(value);

export default function AssetCardImage({ display, asset }) {
  const { user } = useAuth();
  const { settings } = user.company;
  const images = orderBy(asset.images, ["default", "id"]).reverse();

  const NO_IMAGE_AVAILABLE = settings.no_image_placeholder
    ? "/images/no-image-available.png"
    : null;

  return images.length >= 1 ? (
    <Box position="relative" sx={styles.sliderContainer}>
      <Slider {...sliderSettings}>
        {images.map((image, index) => (
          <CardMedia
            key={`cardImg-${index}`}
            sx={styles.image}
            image={image.url ? getImage(image.url, "width", 400) : NO_IMAGE_AVAILABLE}
            loading="lazy"
          />
        ))}
      </Slider>
      {[asset.itemId, asset.barcode].some(notNA) && (
        <Box sx={styles.assetIdLabel}>
          <Label color="contrast">
            {[asset.itemId, asset.barcode].filter(notNA).join(" || ")}
          </Label>
        </Box>
      )}
    </Box>
  ) : (
    <Box position="relative">
      <CardMedia sx={styles.image} image={NO_IMAGE_AVAILABLE} />
      {[asset.itemId, asset.barcode].some(notNA) && (
        <Box sx={styles.assetIdLabel}>
          <Label color="contrast">
            {[asset.itemId, asset.barcode].filter(notNA).join(" || ")}
          </Label>
        </Box>
      )}
    </Box>
  );
}
